/**
 * Search and display constants
 */

/** Maximum number of location suggestions to return in search results */
export const MAX_LOCATION_SUGGESTIONS = 10;

/** Minimum search term length required to trigger search */
export const MIN_SEARCH_TERM_LENGTH = 2;

/** Debounce time (ms) for search input before making API call */
export const SEARCH_DEBOUNCE_TIME = 650;
